
import { Component, Prop, Vue } from 'vue-property-decorator';
import PrizeItem from './_PrizeItem.vue';

import { day } from '@/utils/common';
import { iDailyCheckInSetting } from '@/interface/prize';
@Component({
  components: { PrizeItem },
})
export default class extends Vue {
  @Prop() prizeType!: object[];
  @Prop() prizeList!: iDailyCheckInSetting[] | iDailyCheckInSetting;
  @Prop() isShowDay!: boolean;
  @Prop() isDisabled!: boolean;

  @Prop({ default: true }) isShowNameUnit!: boolean;
  getDay(index: number) {
    return day[index];
  }
}
